import Module from '../utils/Module'

export default class FormModule extends Module {
  constructor (options) {
    super(options)

    this.DOMEl = this.options.element;

    this.formContainer = this.DOMEl.querySelector('form');


    this.init();
  }

  init () {
    this.inputsFieldContainers = this.formContainer.querySelectorAll(".form-item");

    this.inputsFieldContainers.forEach(inputContainer => {
      if(inputContainer.querySelector('input')) {
        inputContainer.querySelector('input').addEventListener("keyup", this.onKeyup.bind(this));
      }

      if(inputContainer.querySelector('textarea')) {
        inputContainer.querySelector('textarea').addEventListener("keyup", this.onKeyup.bind(this));
      }

    });
  }

  onKeyup (e) {
    const inputLabel = e.target.parentNode.querySelector(".item-form-label");
    const textAreaLabel = e.target.parentNode.parentNode.querySelector(".item-form-label")
    const label = inputLabel ? inputLabel : textAreaLabel ? textAreaLabel: null;

    if(e.target.value) {
      //display labels
      if(label) {
        label.classList.add('show-label');
      }
    }else{
      //hide label
      if(label) {
        label.classList.remove('show-label');
      }
    }
  }
}
